import { render, staticRenderFns } from "./companyEdit.vue?vue&type=template&id=67c61478&"
import script from "./companyEdit.vue?vue&type=script&lang=js&"
export * from "./companyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports